import api from './api';

const PAGE_SIZE = 100;
const SAFETY_CAP = 2000;

/**
 * Paginate through an endpoint that returns an array directly.
 * Keeps fetching until a page returns fewer items than PAGE_SIZE or SAFETY_CAP is hit.
 */
const paginateArray = async (url) => {
  let all = [];
  let skip = 0;
  while (skip < SAFETY_CAP) {
    const response = await api.get(url, { params: { skip, limit: PAGE_SIZE } });
    const items = response.data;
    if (!Array.isArray(items) || items.length === 0) break;
    all = all.concat(items);
    if (items.length < PAGE_SIZE) break;
    skip += PAGE_SIZE;
  }
  return all;
};

/**
 * Paginate through an endpoint that returns { data: [], count: N }.
 */
const paginateDataEnvelope = async (url) => {
  let all = [];
  let skip = 0;
  while (skip < SAFETY_CAP) {
    const response = await api.get(url, { params: { skip, limit: PAGE_SIZE } });
    const payload = response.data;
    const items = payload.data || payload;
    if (!Array.isArray(items) || items.length === 0) break;
    all = all.concat(items);
    if (items.length < PAGE_SIZE) break;
    skip += PAGE_SIZE;
  }
  return all;
};

const analyticsService = {
  /**
   * Fetch all recognitions from the feed endpoint (paginated).
   * Each item has: id, sender, recipient, message, timestamp, points_amount, points_status, recognition_type
   */
  fetchAllRecognitions: () => paginateArray('/api/v1/recognitions/feed'),

  /**
   * Fetch all users (paginated). Uses { data, count } envelope.
   */
  fetchAllUsers: () => paginateDataEnvelope('/api/v1/users/'),

  /**
   * Fetch all teams (non-paginated, returns array).
   */
  fetchAllTeams: async () => {
    const response = await api.get('/api/v1/teams/');
    return response.data || [];
  },

  /**
   * Fetch all budgets (non-paginated, returns array).
   */
  fetchAllBudgets: async () => {
    const response = await api.get('/api/v1/admin/budgets/');
    return response.data || [];
  },

  /**
   * Fetch recognition types (non-paginated, returns array).
   */
  fetchRecognitionTypes: async () => {
    const response = await api.get('/api/v1/recognitions/types');
    return response.data || [];
  },
};

export default analyticsService;
